<div class="card" id="card-config">
  <div class="head">
    <h1>Contratos</h1>
    <div class="row">
      <div class="col-md-2">
        <label class="w-100"> Grupos do Cliente:
          <select class="form-control" type="number" [(ngModel)]="clienteId" (ngModelChange)="listarContratoPaginate()">
            <option value="0">
              Todos os clientes
            </option>
            <option [value]="cliente.sr_id" *ngFor="let cliente of clientes">
              {{cliente.vc_nome}}
            </option>
          </select>
        </label>
      </div>
      <div class="col-md-auto">
        <label class="w-100">Pesquisar:
            <input id="searchbar" matInput (keyup)="pesquisarContrato($event)" name="search" class="form-control filtroProduto" type="search" placeholder="Digite o produto...">
        </label>
      </div>
      <div class="col-md-5" id="ordenacao">
        <form id="ordenacaoData" fxFlex.lt-md="60" fxLayout="row" fxLayoutAlign="center center">
            <label class="ordenacao"> Ordenar por:
                <input type="radio" name="opcao" id="opcao1" class="radio-ordenacao" value="todos" (click)="ordenarData(0)" checked/>
                <label for="opcao1" class="opcoes"> Data de Criação </label>&nbsp;
                <input type="radio" name="opcao" id="opcao2" class="radio-ordenacao" value="ordenada" (click)="ordenarData(1)"/>
                <label for="opcao2" class="opcoes"> Data do vencimento </label>&nbsp;    
        </label>
        </form>
     </div>
      <div class="col botao-cadastro">
        <button *ngIf="verificarPermissao(['cadastra_contrato'])" class="btn-nav" routerLink="../contratos/cadastro">
          <mat-icon class="material-icons-sharp">
            note_add
          </mat-icon> Novo contrato
        </button>
      </div>
    </div>
  </div>
  <div class="table-responsive overflow">
    <table mat-table [dataSource]="dataSource" class="table" matSort>
        <ng-container matColumnDef="fk_produto">
            <th mat-header-cell *matHeaderCellDef class="fk_produto" mat-sort-header>Produto</th>
            <td mat-cell *matCellDef="let contrato" class="fk_produto" [class.red]="contrato.ts_cancelado_em != null">
                <span *ngIf="contrato">
                 {{contrato.produtos?.vc_nome}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="ts_data_vencimento">
            <th mat-header-cell *matHeaderCellDef class="ts_data_vencimento" mat-sort-header (click)="ordenarData(ordenacaoData === 1 ? -1 : 1)">Data do vencimento</th>
            <td mat-cell *matCellDef="let contrato" class="ts_data_vencimento" [class.red]="contrato.ts_cancelado_em != null">
                <span *ngIf="contrato"> 
                  {{contrato.ts_data_vencimento}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="ts_renovado_em">
            <th mat-header-cell *matHeaderCellDef class="ts_renovado_em" mat-sort-header>Data da renovação</th>
            <td mat-cell *matCellDef="let contrato" class="ts_renovado_em" [class.red]="contrato.ts_cancelado_em != null">
              <span *ngIf="contrato">
                  {{contrato.ts_renovado_em}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="ts_cancelado_em">
            <th mat-header-cell *matHeaderCellDef class="ts_cancelado_em" mat-sort-header>Data do cancelamento</th>
            <td mat-cell *matCellDef="let contrato" class="ts_cancelado_em" [class.red]="contrato.ts_cancelado_em != null">
                <span *ngIf="contrato">
                    {{contrato.ts_cancelado_em | date:'dd/MM/yyyy'}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="acaoEditar">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="acaoEditar">Ações</th>
          <td mat-cell *matCellDef="let contrato" class="acaoEditar">
            <button *ngIf="verificarPermissao(['edita_contrato'])" class="btn-nav" [routerLink]="['../contratos/atualizar/', contrato?.sr_id]">
              <mat-icon class="material-icons-sharp">
                edit
              </mat-icon>Editar
            </button>
          </td>
        </ng-container>
        
        <ng-container matColumnDef="acaoRenovar">
          <th mat-header-cell *matHeaderCellDef class="acaoRenovar"></th>
          <td mat-cell *matCellDef="let contrato" class="acaoRenovar" [ngClass]="{'acaoRenovar': verificarPermissao(['edita_contrato']) && contrato?.ts_renovado_em == null && contrato?.ts_cancelado_em == null}">
            <button *ngIf=" verificarPermissaoRenovar(contrato)" class="btn-nav blue" (click)="Opendialog('renovação', contrato?.sr_id)">
              <mat-icon class="material-icons-sharp">
                task
              </mat-icon>Renovar
            </button>
          </td>
        </ng-container>
        
        <ng-container matColumnDef="acaoCancelar">
          <th mat-header-cell *matHeaderCellDef class="acaoCancelar"></th>
          <td mat-cell *matCellDef="let contrato" class="acaoCancelar" [ngClass]="{'acaoRenovar': verificarPermissao(['edita_contrato']) && contrato.ts_renovado_em==null && contrato.ts_cancelado_em==null}">
            <button *ngIf="verificarPermissaoRenovar(contrato)" class="btn-nav del" (click)="Opendialog('cancelamento', contrato?.sr_id)">
              <mat-icon class="material-icons-sharp">
                content_cut
              </mat-icon>Cancelar
            </button>
          </td>
        </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
        <div class="mensagem" id="resp" *ngIf="validaResp">
            <p class="text-center">Não há contratos para esse cliente</p>
        </div>     
  </div>
      <div class="load" *ngIf="load">
        <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
        </mat-progress-spinner>
      </div>
      <mat-paginator fxLayoutAlign="center center" pageSize="15">
      </mat-paginator> 
</div>




 